import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = {
  id: number;
};
export type CreateReservationHoldIntent = {
  data: {
    stripeSecret: string;
    reservationId: number;
    ephemeralKey: string;
    customerSessionSecret: string;
    stripeCustomerId: string;
  };
};

export const useCreateReservationHoldIntent = createMutation<
  CreateReservationHoldIntent,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/hold-intent`,
      method: 'POST',
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
